import { Component, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { VentaService } from 'src/app/services/venta.service';
import { Observable } from 'rxjs';
import { Vendedor } from 'src/app/interfaces/vendedor.interface';
import { Caja } from 'src/app/interfaces/caja.interface';
moment.locale('es');

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  vendors: Observable<Vendedor>;

  constructor(private router: Router,
              public service: VentaService) { }

  ngOnInit(): void {

    this.service.auth().then(response => {
      this.obtenerCaja();
      this.service.obtenerFiles();
      this.service.obtenerImpresora().subscribe(
        (res: any) => this.service.impresora = res.nombre,
        (error) => console.log(error)
      );
    });

    
  }

  obtenerCaja() {

    this.service.obtenerCaja('0').subscribe( 
      response => {

        if (0 in response) {
          this.service.caja = response[0];
          this.service.isAuthenticated = true;
          this.router.navigate(['/venta']);
        } else {
          this.service.obtenerVendors(true).subscribe(
            (res) => this.vendors = res
          )
        }
      },
      error => {
        console.log(error);
      }
    );
  }

  async crearCaja(vendor: Vendedor) {
    const caja: Caja = {
      apertura: moment().format('YYYY-MM-DD HH:mm:ss'),
      cierre: '',
      fondo: 0,
      estado: '0',
      vendedor: vendor,
      remesas: [],
      salidas: []
    };

    await this.service.crearCaja(caja);
  }
}
